import { Stack } from "@mui/material";
import DOMPurify from "dompurify";
import { FC } from "react";
import savingsStrategyImage from "../../../assets/images/savings-strategy.jpg";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import { MuiImage } from "../MuiImage";
import { DefaultStepProps } from "../Stepper/CustomStepper";
import { HeadingL } from "../Typography";
import * as Styled from "./InvestmentStrategyIntroPage.styled";

export const InvestmentStrategyIntroPage: FC<DefaultStepProps> = () => {
    const { t } = useTypedTranslation();

    const dirtyInvestmentIntro = t("investmentStrategy.introHtml");
    const cleanInvestmentIntro = DOMPurify.sanitize(dirtyInvestmentIntro, {
        ALLOWED_TAGS: ["strong"],
        ALLOWED_ATTR: [],
    });

    return (
        <Styled.InvestmentStrategyIntroStack>
            <HeadingL>{t("investmentStrategy.savingsStrategy")}</HeadingL>
            <Stack spacing={5}>
                <Styled.InvestmentStrategyIntroImageBox>
                    <MuiImage src={savingsStrategyImage} />
                </Styled.InvestmentStrategyIntroImageBox>

                <Styled.InvestmentStrategyIntroBodyTextM
                    component="p"
                    dangerouslySetInnerHTML={{ __html: cleanInvestmentIntro }}
                />
            </Stack>
        </Styled.InvestmentStrategyIntroStack>
    );
};
